module.exports = __webpack_public_path__ + "static/media/cases_3d_keslon_02.25832926.jpg";